import { apiService } from '../APIService';
import { CRUDFactory } from '../CRUDFactory';

/**
 *  Проекты с которых будут поступать заявки
*/
export const CRUDProjects = CRUDFactory('projects');

export default {
  projectQuestionCategories(id, params) {
    return apiService.get(`/projects/${id}/question-categories`, params);
  },

  attachUser(id, params) {
    return apiService.post(`/projects/${id}/attach-user`, params);
  },

  detachUser(id, params) {
    return apiService.post(`/projects/${id}/detach-user`, params);
  },

  attachCategory(id, params) {
    return apiService.post(`/projects/${id}/attach-category`, params);
  },

  detachCategory(id, params) {
    return apiService.post(`/projects/${id}/detach-category`, params);
  },
};
